import type { SupportedLocale } from '@/lib/utils/localization/getFlattenedLocales'
import { getCosmicProductsBanner } from './cosmic/fetchFunctions/getCosmicProductsBanner'
import type { CMSResult } from './types/CMSError'

export type GetProductsBannerProps = {
  locale: SupportedLocale
}

export const getProductsBanner = async ({
  locale,
}: GetProductsBannerProps): Promise<
  CMSResult<ReturnType<typeof getCosmicProductsBanner>>
> => {
  try {
    const productsBanner = await getCosmicProductsBanner({
      locale,
    })

    if (!productsBanner?.data.productsBanner[0]?.data) {
      return {
        error: {
          code: 'COSMIC_BANNER_DATA_MISSING',
          message:
            'Some promotional content is temporarily unavailable. The page will continue to function normally.',
          source: 'cosmic',
          timestamp: new Date().toISOString(),
        },
      }
    }

    return productsBanner
  } catch {
    const errorDetails = {
      code: 'COSMIC_BANNER_FETCH_FAILED',
      message:
        "We're having trouble loading some promotional content. The rest of the page should work as expected.",
      source: 'cosmic' as const,
      timestamp: new Date().toISOString(),
    }

    console.error('COSMIC: Unable to fetch products banner data:', errorDetails)
    return { error: errorDetails }
  }
}
